import Api from '@/services/Api';

export default {
  getICCIDUsage(idCounter) {
    return Api().get('iccidUsage', {
      params: {
        idCounter,
      },
    });
  },
};
